
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"16","viewBox":"0 0 19 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M18.448 2.726c-.756-1.414-2.163-2.4-3.794-2.657a5.345 5.345 0 00-4.477 1.355l-.676.595-.655-.574C7.664.315 5.986-.198 4.342.07 2.708.315 1.297 1.304.554 2.726c-1.005 1.894-.617 4.196.958 5.689l7.421 7.354c.15.148.354.231.568.231a.807.807 0 00.567-.23l7.411-7.342c1.582-1.493 1.974-3.801.969-5.702z"}})])
          )
        }
      }
    